import { render } from "./GenerateEvaluation.vue?vue&type=template&id=1f477b34&scoped=true"
import script from "./GenerateEvaluation.vue?vue&type=script&lang=js"
export * from "./GenerateEvaluation.vue?vue&type=script&lang=js"

import "./GenerateEvaluation.vue?vue&type=style&index=0&id=1f477b34&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f477b34"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInnerLoading});
